import { CheckCircleIcon, XCircleIcon, XMarkIcon } from '@heroicons/react/24/outline'

type ModalType = 'success' | 'cancelled'

type Props = {
  isOpen: boolean
  type: ModalType | null
  onClose: () => void
}

export const BillingConfirmationModal = ({ isOpen, type, onClose }: Props) => {
  if (!isOpen || !type) {
    return null
  }

  const isSuccess = type === 'success'

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 dark:bg-app-page/80 px-4 backdrop-blur">
      <div className="relative w-full max-w-md rounded-2xl border border-app-line bg-app-surface shadow-2xl p-6">
        {/* Close button (X) */}
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-app-muted hover:text-app-ink transition-colors"
          aria-label="Close"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>

        {/* Icon */}
        <div className={`mx-auto w-12 h-12 rounded-full flex items-center justify-center mb-4 ${
          isSuccess
            ? 'bg-emerald-50 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400'
            : 'bg-app-surface text-app-muted'
        }`}>
          {isSuccess ? (
            <CheckCircleIcon className="w-6 h-6" />
          ) : (
            <XCircleIcon className="w-6 h-6" />
          )}
        </div>

        {/* Title */}
        <h2 className="text-xl font-bold text-app-ink text-center mb-2 font-display">
          {isSuccess ? 'Payment Successful!' : 'Checkout Cancelled'}
        </h2>

        {/* Message */}
        <p className="text-sm text-app-muted text-center mb-6">
          {isSuccess
            ? 'Your subscription has been activated. You now have access to all Pro features!'
            : 'No worries! You can upgrade to Pro anytime from the pricing page.'
          }
        </p>

        {/* OK Button */}
        <button
          onClick={onClose}
          className={`w-full rounded-xl px-4 py-3 text-sm font-semibold transition-colors ${
            isSuccess
              ? 'bg-app-primary text-white hover:bg-app-primary-hover'
              : 'bg-app-surface text-app-ink hover:bg-app-surface'
          }`}
        >
          OK
        </button>
      </div>
    </div>
  )
}

